/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The page an invitation link opens, whose first reads the exchange returns.
 */
export type InterviewEntryPage =
  (typeof InterviewEntryPage)[keyof typeof InterviewEntryPage];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InterviewEntryPage = {
  landing: 'landing',
  scheduling: 'scheduling',
} as const;
